import { DealsContext, GOLD_PACKS } from "@highmarch/app";
import { dealsLink } from "../ui/deals/dealsLink";
import type { Feature } from "./registry";
import { ECONOMY_FROM_CLEARED } from "./economy";

/**
 * Offers suggested from the save (MONETISATION_PLAN MP-05; rules in @highmarch/app offerTriggers.ts, state in the catalog's
 * `offerTriggers` save section). Presentation glue only, and only badges: the Shop tab's red dot when a short purse
 * points at the gold packs (the Shop's Gems page clears it), and each hub visit lets a return open the Welcome Back
 * window. The Deals pill's count and the Deals strip's dots come through Deals.badge and ui/deals/suggestTabs.ts; the
 * pack beside the welcome-back gift is ui/hub/welcomePackCard.ts. Nothing here opens a sheet.
 */

const NO_STORE: DealsContext = { paidAllowed: false, storefront: null };

export const offerTriggersFeature: Feature = {
  id: "offerTriggers",
  register(ctx, registry) {
    const t = () => ctx.catalog.offerTriggers;
    const dealsCtx = (): DealsContext => dealsLink()?.ctx() ?? NO_STORE;

    registry.tabBadge({
      tab: "shop",
      count: () => (ctx.catalog.highestLevelCleared >= ECONOMY_FROM_CLEARED && t().suggestions(ctx.now(), dealsCtx()).goldPacks ? 1 : 0),
    });

    // A hub visit after days away (the check-in's welcome-back gift is due) opens the Welcome Back window, once.
    registry.hubWidget({
      id: "offerTriggers",
      mount: (hub) => {
        if (t().refresh(ctx.now())) hub.changed();
        return { dispose: () => undefined };
      },
    });

    if (ctx.debug && typeof window !== "undefined") {
      // Captures: what is suggested now, and the save facts behind it.
      (window as unknown as { __tdTriggers: unknown }).__tdTriggers = {
        triggers: t,
        suggestions: () => t().suggestions(ctx.now(), dealsCtx()),
        goldPacks: GOLD_PACKS,
      };
    }
  },
};
